<template>
	<form ref="form" class="ui-form" @submit.prevent="onSubmit">
		<slot/>
	</form>
</template>

<script>
export default {
	props: {

	},

	data: () => ({
		hasError: false
	}),

	methods: {
		onSubmit() {
			this.hasError = false;
			this.traverseVueChildren(this);

			if (this.hasError) {
				return;
			}

			this.$emit('submit');
		},

		traverseVueChildren(component) {
			if (!component.$children || component.$children.length === 0) {
				return;
			}

			component.$children.forEach(child => {
				if ('validateInput' in child) {
					child.validateInput();
				}

				if ('validationError' in child && Boolean(child.validationError)) {
					this.hasError = true;
				}

				this.traverseVueChildren(child);
			});
		}
	}
};
</script>

<style lang="scss">
.ui-form {
	max-height: 100%;
}
</style>
